import React, { useEffect, useState, useImperativeHandle } from "react";
import jsPDF from "jspdf";
const Certificate = React.forwardRef(({ studentName, certificateFile, questName }, ref) => {
  const [assetsLoaded, setAssetsLoaded] = useState(false);
  const [imageCache, setImageCache] = useState({
    background: null,
    logo: null,
    badge: null,
  });

  const loadImage = (src) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });

  useEffect(() => {
    const preloadAssets = async () => {
      try {
        const [bg, logo, badge] = await Promise.all([

          loadImage("https://yuvaquest-public-bucket-s3.s3.us-east-2.amazonaws.com/static/studentadmin/award/certificatepdf/Background-min.png"),
          loadImage("https://yuvaquest-public-bucket-s3.s3.us-east-2.amazonaws.com/static/studentadmin/award/certificatepdf/Logo-min.png"),
          loadImage("https://yuvaquest-public-bucket-s3.s3.us-east-2.amazonaws.com/static/studentadmin/award/certificatepdf/ExcellentBadge-min.png"),

        ]);
        setImageCache({ background: bg, logo, badge });
        setAssetsLoaded(true);
      } catch (err) {
        console.error("Failed to preload images:", err);
        setAssetsLoaded(false);
      }
    };

    preloadAssets();
  }, []);

  const compressToJpeg = (base64Png) =>
    new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const jpegBase64 = canvas.toDataURL("image/jpeg", 0.6);
        resolve(jpegBase64);
      };
      img.src = base64Png;
    });

  const generateCertificate = async (questName) => {
    if (!assetsLoaded) {
      alert("Please wait, certificate assets are still loading...");
      return;
    }

    if (!certificateFile) {
      alert("Certificate image is not loaded yet. Please wait and try again.");
      return;
    }

    const doc = new jsPDF("landscape", "mm", "a4");
    doc.addImage(imageCache.background, "JPEG", 10, 10, 277, 190);
    doc.addImage(imageCache.logo, "JPEG", 30, 35, 30, 20);
    doc.setFont("Helvetica", "bold");
    doc.setFontSize(50);
    doc.setTextColor("#ffffff");
    doc.text("CERTIFICATE", 145, 48, { align: "center" });
    doc.addImage(imageCache.badge, "JPEG", 230, 30, 40, 35);

    doc.setFontSize(30);
    doc.text("OF ACHIEVEMENT", 145, 60, { align: "center" });
    doc.setFont("Times", "normal");
    doc.setFontSize(15);
    doc.text("This certificate is proudly awarded to", 145, 80, { align: "center" });

    const name = studentName || "Student Name";
    doc.setFont("Helvetica", "bold");
    doc.setFontSize(50);
    const textWidth = doc.getTextWidth(name);
    const startY = 105;
    doc.text(name, 144, startY, { align: "center" });

    doc.setDrawColor("#ffffff");
    doc.setLineWidth(0.8);
    doc.line(145 - textWidth / 2, startY + 5, 145 + textWidth / 2, startY + 5);

    doc.setFont("Times", "normal");
    doc.setFontSize(15);
    doc.text(`For successfully completing ${questName}`, 145, 120, { align: "center" });

    let compressedCertFile = certificateFile;
    if (certificateFile.startsWith("data:image/png")) {
      compressedCertFile = await compressToJpeg(certificateFile);
    }

    doc.addImage(compressedCertFile, "JPEG", 85, 130, 120, 32);
    doc.setFontSize(15);
    doc.text("www.yuvaquest.com", 145, 180, { align: "center" });
    doc.save(`${questName}.pdf`);
  };

  useImperativeHandle(ref, () => ({
    generateCertificate,
    isReady: assetsLoaded,
  }));

  return null;
});

export default Certificate;